// @ts-expect-error types missing
import FeedbackLoader from 'feedback-loader';
import { CSAT_ABM } from 'ui-forms-components/constants/FeedbackSurveys';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorFeedbackSurvey = ({
  feedbackId = CSAT_ABM.PROD
}) => /*#__PURE__*/_jsx(FeedbackLoader, {
  onClientLoad: feedbackClient => {
    feedbackClient.loadSurvey('CSAT', feedbackId);
  }
});
export default EditorFeedbackSurvey;